import { Dispatch, AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import networkApi from "../../service/network";
import {
  appLogout,
  loginFail,
  loginInit,
  loginSuccess,
  updateUserProfileFail,
  updateUserProfileInit,
  updateUserProfileSuccess,
  dashboardInit,
  dashboardSuccess,
  dashboardFail,
  setUserCurrentScreen,
} from "../action/app";
import { store } from "../store/store";
import config from "../../config";
import { open500ErrorPage } from "../../navigators/routes";

export const userLogout = async () => {
  const dispatch = store.dispatch;
  await dispatch(appLogout());
  //Router.openLoginPage();
};

export const login =
  ({ phoneNumber, phoneUId, idToken }) =>
  (dispatch, getState) => {
    dispatch(loginInit());

    return networkApi(config.apis.login, {
      phone_number: phoneNumber,
      phone_uid: phoneUId,
      id_token: idToken,
    })
      .then((response) => {
        if (response?.data?.data) {
          dispatch(loginSuccess(response.data.data));
        } else {
          dispatch(loginFail());
        }
        return response.data.data;
      })
      .catch((errors) => {
        dispatch(setUserCurrentScreen(config.routes.networkError));
        open500ErrorPage()
        dispatch(loginFail(errors));
        throw errors;
      });
  };

export const dashboard =
  ({ action }) =>
  (dispatch, getState) => {
    dispatch(dashboardInit());

    return networkApi(config.apis.dashboard, {
      action,
    })
      .then((response) => {
        if (response?.data?.data) {
          dispatch(dashboardSuccess(response.data.data));
        } else {
          dispatch(dashboardFail());
        }
        return response.data.data;
      })
      .catch((errors) => {
        dispatch(setUserCurrentScreen(config.routes.networkError));
        open500ErrorPage()
        dispatch(dashboardFail(errors));
        throw errors;
      });
  };

export const updateUserProfile =
  ({
    firstName,
    lastName,
    email,
    dob,
    street,
    apartment,
    city,
    state,
    zip,
    ssn,
    accountNumber,
    routingNumber,
    annualIncome,
    annualIncomeMin,
    annualIncomeMax,
    liquidAssets,
    liquidAssetsMin,
    liquidAssetsMax,
    citizenship,
    employmentStatus,
    nameOfEmployer,
    employerAddress,
    employerJobName,
    specialSituation,
    riskQuestionnaire,
    riskRecommendation,
    accountFundingSource,
    authStatement,
    fingerprint,
  }) =>
  (dispatch, getState) => {
    dispatch(updateUserProfileInit());
    let data = {};
    if (firstName || lastName) {
      data = {
        pii: {
          pii_first_name: firstName,
          pii_last_name: lastName,
        },
      };
    }

    if (email) {
      data = {
        pii: {
          pii_email: email,
        },
      };
    }

    if (dob) {
      data = {
        pii: {
          pii_dob: dob,
        },
      };
    }

    if (street || apartment || city || state || zip) {
      data = {
        pii: {
          pii_address: {
            street: street,
            apt: apartment,
            city: city,
            state: state,
            zip: zip,
          },
        },
      };
    }

    if (annualIncome || annualIncomeMin || annualIncomeMax) {
      data = {
        survey: {
          annual_income: annualIncome,
          annual_income_min: annualIncomeMin,
          annual_income_max: annualIncomeMax,
        },
      };
    }

    if (liquidAssets || liquidAssetsMin || liquidAssetsMax) {
      data = {
        survey: {
          liquid_assets: liquidAssets,
          liquid_assets_min: liquidAssetsMin,
          liquid_assets_max: liquidAssetsMax,
        },
      };
    }

    if (citizenship) {
      data = {
        survey: {
          us_citizenship: citizenship,
        },
      };
    }

    if (ssn) {
      data = {
        pii: {
          pii_ssn: ssn,
        },
      };
    }

    if (
      employmentStatus ||
      nameOfEmployer ||
      employerAddress ||
      employerJobName
    ) {
      data = {
        survey: {
          employment_status: employmentStatus,
          employer_details: {
            name: nameOfEmployer,
            address: employerAddress,
            job_name: employerJobName,
          },
        },
      };
    }

    if (specialSituation) {
      data = {
        survey: {
          special_situation: specialSituation,
        },
      };
    }

    if (riskQuestionnaire) {
      data = {
        survey: {
          risk_questionnaire: riskQuestionnaire,
        },
      };
    }

    if (riskRecommendation) {
      data = {
        survey: {
          risk_recommendation: riskRecommendation,
        },
      };
    }

    if (accountFundingSource) {
      data = {
        survey: {
          account_funding_source: accountFundingSource,
        },
      };
    }

    if (accountNumber || routingNumber) {
      data = {
        checking: {
          checking_account_number: accountNumber,
          checking_routing_number: routingNumber,
        },
      };
    }

    if (authStatement || fingerprint) {
      data = {
        auth_signal: {
          auth_statement: authStatement,
          fingerprint: {
            ip: fingerprint,
          },
        },
      };
    }

    return networkApi(config.apis.profileUpdate, data)
      .then((response) => {
        if (response?.data?.data) {
          dispatch(updateUserProfileSuccess(response.data.data));
        } else {
          dispatch(updateUserProfileFail());
        }
        return response.data.data;
      })
      .catch((errors) => {
        dispatch(setUserCurrentScreen(config.routes.networkError));
        open500ErrorPage()
        dispatch(updateUserProfileFail(errors));
        throw errors;
      });
  };
